module.exports = __webpack_public_path__ + "img/fe72c60.jpg";